import { Divider, Drawer } from 'antd';
import { useToggle } from 'react-use';
import classNames from 'classnames';
import { useConfigProvider } from '@/context/ConfigProvider';
import styles from './index.module.less';
import { useCallback, useEffect, type ReactNode } from 'react';
import { useUserProvider } from '@/context/UserProvider';
// import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import dynamic from 'next/dynamic';

// 使用 dynamic 导入并禁用 SSR，避免水合错误
const LeftFolder = dynamic(() => import('../leftFolder/index'), {
  ssr: false,
});

const NavHamburger = ({ children, iNode }: { children?: ReactNode; iNode?: ReactNode }) => {
  const { isMobile } = useConfigProvider();
  const { isLogin, onOpenLoginModal, onChangedLoginView, onSignOut } = useUserProvider();
  const [open, setOpen] = useToggle(false);
  const router = useRouter();
  const { t } = useTranslation('common');

  // 当侧边栏打开时，禁用背景滚动
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (!open) return;

    const scrollY = window.scrollY;

    const originalStyle = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
    };

    // 🔒 锁滚动（核心）
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    return () => {
      // 🔓 解锁
      document.body.style.position = originalStyle.position;
      document.body.style.top = originalStyle.top;
      document.body.style.left = originalStyle.left;
      document.body.style.right = originalStyle.right;
      document.body.style.width = originalStyle.width;

      window.scrollTo(0, scrollY);
    };
  }, [open]);

  const showLogin = (loginView: boolean) => {
    onOpenLoginModal(true);
    onChangedLoginView(loginView);
  };

  return (
    <div
      className={classNames(styles.navHamburgerWarp, {
        [styles.showClose]: open,
      })}
    >
      {iNode
        ? iNode
        : new Array(3)
            .fill(1)
            .map((_, index) => (
              <span onClick={() => setOpen(true)} key={`burger-${index}`} className={styles.hamburgerLine} />
            ))}
      <Drawer
        style={{ background: `var(--foreground-rgb)` }}
        title={null}
        closeIcon={null}
        width={isMobile ? 250 : 400}
        placement="left"
        onClose={(e) => {
          e.stopPropagation();
          setOpen(false);
        }}
        open={open}
        maskClosable={true}
        rootClassName={styles.leftMenuDrawerWarp}
      >
        <div onClick={() => setOpen(false)}>
          <LeftFolder></LeftFolder>
        </div>
      </Drawer>
    </div>
  );
};

export default NavHamburger;
